define("active-model-adapter/initializers/active-model-adapter", ["exports", "active-model-adapter"], function (_exports, _activeModelAdapter) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _exports.initialize = initialize;
  0; //eaimeta@70e063a35619d71f0,"active-model-adapter"eaimeta@70e063a35619d71f
  function initialize(application) {
    application.register('adapter:-active-model', _activeModelAdapter.ActiveModelAdapter);
    application.register('serializer:-active-model', _activeModelAdapter.ActiveModelSerializer);
  }
  var _default = _exports.default = {
    initialize
  };
});